import React, { useState } from "react";
import Image from "next/image";

function CollapseClose() {
  const [isAnsVisible, setIsAnsVisible] = useState(false);

  const toggleAnsVisibility = () => {
    if (isAnsVisible) setIsAnsVisible(false);
    else setIsAnsVisible(true);
  };

  return (
    <div className="py-[2rem] border-b-[1px] border-[#CBD0D6]">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={toggleAnsVisibility}
      >
        <h4 className="text-[1.25rem] leading[2rem]">
          What are the payment options at AmarPet.com?
        </h4>

        <div className="min-w-[14px] ml-[1.625rem]">
          <Image
            src={`${
              isAnsVisible
                ? "/assets/icons/red-minus.svg"
                : "/assets/icons/red-plus.svg"
            }`}
            width={14}
            height={14}
            alt="auth-image"
          />
        </div>
      </div>
      <div className={`${isAnsVisible ? "" : "hidden"}`}>
        <p className="text-grayD3 text-body1 mt-[1.5rem]">
          We offer various payment options according to our customers’
          convenience. To purchase online, you can use:
        </p>

        <ul className="list-disc ml-[2rem] text-grayD3">
          <li>
            debit card/credit card - Visa, Mastercard, American Express, Nexus
            card
          </li>
          <li>mobile payment - bKash, Nagad</li>
          <li>Cash on delivery - pay in cash when you receive the product</li>
        </ul>
      </div>
    </div>
  );
}

export default CollapseClose;
